import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";

import { updateClassificationConfiguration } from "@/api/classifications-api";
import { type ClassificationConfiguration } from "@/schemas";

import { CLASSIFICATIONS_QUERY_KEY } from "./use-classifications";

export const useUpdateClassification = (classificationId: string | undefined) => {
	const intl = useIntl();
	const queryClient = useQueryClient();

	return useMutation<void, Error, ClassificationConfiguration>({
		mutationFn: (data: ClassificationConfiguration) => {
			if (!classificationId) {
				throw new Error("Classification ID is required");
			}

			return updateClassificationConfiguration(classificationId, data, intl);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [CLASSIFICATIONS_QUERY_KEY] });
		},
	});
};
